import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail, fetchOrderList, deviceList } from "@/api/PMS/repair/repairManagement";
import { fetchListByType } from "@/api/PMS/dic/dic";
import { fetchTreeList } from "@/api/PMS/treeList/index.js";
import { setTimeout } from "timers";
export default {
  props: ["keyValue", "showDialog"],
  data: function data() {
    var _this = this;

    var checkUpList = function checkUpList(rule, value, callback) {
      setTimeout(function () {
        if (!value && _this.childData.repairType === 1) {
          return callback(new Error("请输入所属房间"));
        } else if (!value && _this.childData.repairType === 2) {
          return callback(new Error("请输入所属楼栋"));
        } else {
          callback();
        }
      }, 100);
    };

    return {
      ruleForm: {
        repairType: "",
        upIdList: "",
        houseId: "",
        situationType: "",
        contact: "",
        phone: "",
        orderType: "",
        orderSubType: "",
        content: "",
        deviceId: ""
      },
      rules: {
        repairType: [{
          required: true,
          message: "请选择报修类型",
          trigger: "change"
        }],
        upIdList: [{
          required: true,
          message: "数据不能为空",
          trigger: "change"
        }, {
          validator: checkUpList,
          trigger: "change"
        }],
        houseId: [{
          required: true,
          message: "请输入房间代码",
          trigger: "blur"
        }],
        situationType: [{
          required: true,
          message: "请选择工单优先级",
          trigger: "change"
        }],
        contact: [{
          required: true,
          message: "请输入联系人",
          trigger: "blur"
        }],
        phone: [{
          required: true,
          message: "请输入联系电话",
          trigger: "blur"
        }],
        orderType: [{
          required: true,
          message: "请选择工单大类",
          trigger: "change"
        }],
        orderSubType: [{
          required: true,
          message: "请选择工单子类",
          trigger: "change"
        }],
        content: [{
          required: true,
          message: "请输入报修详情",
          trigger: "blur"
        }],
        deviceId: [{
          required: true,
          message: "请选择报修设备",
          trigger: "change"
        }]
      },
      propstree: {
        label: "name",
        value: "id",
        children: "pmsTree"
      },
      oldImgList: [],
      removeList: [],
      addList: [],
      buildingId: "",
      uploadUrl: "",
      dialogImageUrl: "",
      imageUrl: "",
      downloadUrl: "",
      uploadList: [],
      typeRadio: false,
      dialogVisible: false,
      fileList: [],
      options: [],
      cascaderItem: [],
      buildingOptions: [],
      listObj: {},
      deviceList: [],
      sourceOption: [],
      OrderOption: [],
      degreeOption: [],
      HouseCodeList: [],
      isDisabled: false,
      showmatter: true,
      childData: {
        repairType: 1,
        orderSubType: "",
        deviceId: ""
      },
      typeOption: [],
      documentOption: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
  },
  methods: {
    init: function init() {
      var _this2 = this;

      this.buildingId = "";
      this.typeRadio = false;
      this.listObj = {};
      this.cascaderItem = [];
      this.isDisabled = false;
      this.deletePictureList = [];
      this.addList = [];
      this.removeList = [];
      this.typeOption = [];
      this.degreeOption = [];
      this.OrderOption = [];
      this.sourceOption = [];
      this.HouseCodeList = [];
      this.documentOption = [];
      this.loadTypeOptions();
      this.loadOrerOptions();
      this.loadSourceOptions();
      this.loadDegreeOptions();
      this.loadMenuTree();
      this.loadBuiildingTree();
      this.$nextTick(function () {
        _this2.$refs["dataForm"].clearValidate();

        _this2.$refs.upload.clearFiles();
      });

      if (this.keyValue > 0) {
        this.typeRadio = true;
        this.getDeviceList();
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;
          setTimeout(function () {
            _this2.fileList = response.data.data.pictureList.map(function (item) {
              var obj = {};
              obj.url = item.url;
              return obj;
            });
            _this2.listObj = _this2.fileList;
            _this2.oldImgList = _this2.fileList;
          }, 700);

          _this2.$delete(_this2.childData.upIdList, 1); // 删除管理区分组那一项


          _this2.buildingId = response.data.data.upIdList[response.data.data.upIdList.length - 1]; // this.childData.upIdList = this.childData.upIdList.join(",").split(",");

          _this2.loadLitOptions(response.data.data.orderType);
        });
      } else {
        this.deviceList = [];
        this.childData = {
          deviceId: "",
          repairType: 1,
          orderSubType: ""
        };
      }
    },
    loadMenuTree: function loadMenuTree() {
      var _this3 = this;

      var treeQuery = {
        flag: 22
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this3.options = response.data.data;

        _this3.treeFormat(_this3.options); // id变成Number格式，解决级联选择器不回显的问题

      });
    },
    loadBuiildingTree: function loadBuiildingTree() {
      var _this4 = this;

      var treeQuery = {
        flag: 2
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this4.buildingOptions = response.data.data;

        _this4.treeFormat(_this4.buildingOptions); // id变成Number格式，解决级联选择器不回显的问题

      });
    },
    treeFormat: function treeFormat(list) {
      var _this5 = this;

      list.forEach(function (item) {
        _this5.treeChildFormat(item);

        if (item.pmsTree && item.pmsTree.length > 0) {
          _this5.treeFormat(item.pmsTree);
        }
      });
    },
    treeChildFormat: function treeChildFormat(child) {
      this.$set(child, 'id', parseInt(child.id));
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", "repairAdd");
    },
    // 获取报修类型
    loadTypeOptions: function loadTypeOptions() {
      var _this6 = this;

      fetchListByType("repair_type").then(function (r) {
        _this6.typeOption = r.data.data;
      });
    },
    // 获取工单大类
    loadOrerOptions: function loadOrerOptions() {
      var _this7 = this;

      fetchListByType("work_order_parent").then(function (r) {
        _this7.OrderOption = r.data.data;
      });
    },
    // 获取工单子类
    loadLitOptions: function loadLitOptions(val) {
      var _this8 = this;

      fetchOrderList(val).then(function (r) {
        _this8.documentOption = r.data.data;
      });
    },
    // 获取来源
    loadSourceOptions: function loadSourceOptions() {
      var _this9 = this;

      fetchListByType("source").then(function (r) {
        _this9.sourceOption = r.data.data;
      });
    },
    // 获取紧急程度
    loadDegreeOptions: function loadDegreeOptions() {
      var _this10 = this;

      fetchListByType("emergency_degree").then(function (r) {
        _this10.degreeOption = r.data.data;
      });
    },
    // 获取设备列表
    getDeviceList: function getDeviceList(query) {
      var _this11 = this;

      query = query || "";
      var queryData = {
        deviceName: query,
        buildingId: this.buildingId
      };
      deviceList(queryData).then(function (r) {
        _this11.deviceList = r.data.data;
      });
    },
    // 获取级联选择器的下拉选项的数据
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this12 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this12.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    // 检查是否选择下拉框是否选择正确的房间
    checkSelectHouse: function checkSelectHouse() {
      this.cascaderItem = [];
      this.getCascaderItem(this.childData.upIdList, this.options);
      console.log('shebei', this.cascaderItem, this.options);

      if (this.cascaderItem[this.cascaderItem.length - 1].flag !== "22") {
        this.$message({
          message: "请选择正确的房间",
          type: "error",
          duration: 3000
        });
        return false;
      }
    },
    // 检查是否选择下拉框是否选择正确的楼栋
    checkSelectBuild: function checkSelectBuild(val) {
      this.childData.deviceId = "";
      this.deviceList = [];

      if (val) {
        this.isDisabled = false;
        this.buildingId = this.childData.upIdList[this.childData.upIdList.length - 1];
      }

      this.cascaderItem = [];
      this.getCascaderItem(this.childData.upIdList, this.options);
      console.log('shebei', this.cascaderItem, this.options);

      if (this.cascaderItem[this.cascaderItem.length - 1].flag !== "2") {
        this.$message({
          message: "请选择正确的楼栋",
          type: "error",
          duration: 3000
        });
        return false;
      }

      this.getDeviceList();
    },
    // 选择工单子类前检查是否选择工单大类
    checkOrderType: function checkOrderType() {
      if (!this.childData.orderType) {
        this.$message({
          message: "请先选择工单大类",
          type: "error",
          duration: 3000
        });
        return false;
      }
    },
    // 选择设备前检查是否已经选择楼栋
    checkHouseId: function checkHouseId() {
      if (!this.buildingId) {
        this.$message({
          message: "请先选择楼栋",
          type: "error",
          duration: 5000
        });
        this.isDisabled = true;
        return false;
      }

      this.cascaderItem = [];
      this.getCascaderItem(this.childData.upIdList, this.options);

      if (this.cascaderItem[this.cascaderItem.length - 1].flag !== "2") {
        this.$message({
          message: "请选择正确的楼栋",
          type: "error",
          duration: 3000
        });
        return false;
      }
    },
    // 表单切换时重置表单内容
    resetForm: function resetForm() {
      this.listObj = {};
      this.fileList = [];
      this.$refs.upload.clearFiles();
      this.isDisabled = false;

      if (this.childData.repairType === 1) {
        this.childData = {
          repairType: 1,
          orderSubType: "",
          deviceId: ""
        };
        this.$refs["dataForm"].clearValidate();
      } else {
        this.childData = {
          repairType: 2,
          orderSubType: "",
          deviceId: ""
        };
        this.buildingId = "";
        this.deviceList = "";
        this.$refs["dataForm"].clearValidate();
      }
    },
    // 根据工单大类关联工单子类
    changeSelect: function changeSelect(val) {
      this.childData.orderSubType = "";

      switch (val) {
        case "repair_business":
          this.loadLitOptions("repair_business");
          break;

        case "maintain_class":
          this.loadLitOptions("maintain_class");
          break;

        case "public_repair":
          this.loadLitOptions("public_repair");
          break;

        default:
          this.loadLitOptions("");
          break;
      }
    },
    // 上传图片成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      var _this13 = this;

      var imgUrl = response.data[0].filePath + response.data[0].fileUrl;
      this.addList.push({
        url: imgUrl
      });
      var uid = file.uid;
      var objKeyArr = Object.keys(this.listObj);

      for (var i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].name === uid) {
          this.listObj[objKeyArr[i]].url = response.data[0].filePath + response.data[0].fileUrl;
        }
      }

      this.uploadList = Object.keys(this.listObj).map(function (item) {
        return _this13.listObj[item];
      });
    },
    beforeUpload: function beforeUpload(file) {
      var _this14 = this;

      var fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise(function (resolve, reject) {
        _this14.listObj[fileName] = {
          name: file.uid
        };
        resolve(true);
      });
    },
    // 移除图片
    handleRemove: function handleRemove(file) {
      var _this15 = this;

      var uid = file.uid;
      var objKeyArr = Object.keys(this.listObj);

      for (var i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].name === uid) {
          delete this.listObj[objKeyArr[i]];
        }
      }

      this.oldImgList.forEach(function (item) {
        if (item.url === file.url) {
          // var fileId = item.url.split('fileId=')[1]
          _this15.removeList.push({
            url: file.url
          });
        }

        _this15.addList.forEach(function (item, index) {
          if (item.url === file.url) {
            _this15.addList.splice(index, 1);
          }
        });
      });
    },
    // 图片预览
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    changeTowardValue: function changeTowardValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.userCardType === val;
      });
      this.childData.userCardType = obj.dicName;
    },
    handCreate: function handCreate() {
      var _this16 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          if (_this16.childData.repairType !== 2) {
            _this16.childData.areaId = _this16.childData.upIdList[0]; // 区域ID

            _this16.childData.buildingId = _this16.childData.upIdList[// 楼栋ID
            _this16.childData.upIdList.length - 3];
            _this16.childData.houseId = _this16.childData.upIdList[// 房间ID
            _this16.childData.upIdList.length - 1];
          } else {
            _this16.childData.areaId = _this16.childData.upIdList[0]; // 区域ID

            _this16.childData.buildingId = _this16.childData.upIdList[// 楼栋ID
            _this16.childData.upIdList.length - 1];
          }

          _this16.childData.pictureList = _this16.uploadList;

          if (_this16.keyValue > 0) {
            if (_this16.childData.upIdList) {
              delete _this16.childData.upIdList;
            }

            _this16.childData.addPictureList = _this16.addList;
            _this16.childData.deletePictureList = _this16.removeList;
            fetchUpdate(_this16.childData).then(function (res) {
              if (res.data.code === 200) {
                _this16.$emit("handCancle", true);

                _this16.Alert({
                  alertType: "update"
                });
              }
            });
          } else {
            if (_this16.childData.repairType === 1) {
              if (_this16.cascaderItem[_this16.cascaderItem.length - 1].flag !== "22") {
                _this16.$message({
                  message: "上级机构请选择正确的房间",
                  type: "error",
                  duration: 3000
                });

                return false;
              }
            } else {
              if (_this16.cascaderItem[_this16.cascaderItem.length - 1].flag !== "2") {
                _this16.$message({
                  message: "上级机构请选择正确的楼栋",
                  type: "error",
                  duration: 3000
                });

                return false;
              }
            }

            _this16.childData.upIdList = []; // delete this.childData.upIdList;

            fetchCreate(_this16.childData).then(function () {
              _this16.$emit("handCancle", true);

              _this16.Alert({
                alertType: "add"
              });
            });
          }
        } else {
          _this16.Alert({
            alertType: "valid"
          });
        }
      });
    }
  }
};